import { http } from "../client";
export var createPlayStat = function (_a) {
    var trackId = _a.trackId;
    return http.api.post("play-stats", {
        stop_reason: "ended",
        play_duration: 1,
        track_id: trackId,
    });
};
